import { connect } from 'react-redux';
import { hideSnack } from '@/actions/snackbar';
import Snackbar from './Snackbar.jsx';

const mapStateToProps = state => ({
  isShowSnackbar: state.core.isShowSnackbar,
});

const mapDispatchToProps = dispatch => ({
  hideSnack: () => dispatch(hideSnack()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Snackbar);
